<template>
  <footer
    class="contain-content b-t b-grey-50 bg-white content-visibility-auto"
    style="contain-intrinsic-size: auto 100vw auto 51.875rem"
  >
    <div class="mx-a divide-y divide-grey-70" style="max-width: 90rem">
      <vf-footer-loyalty
        v-if="showLoyaltyFooter
          && $feature.enableLoyaltyFeatures
          && !user.isLoyaltyMember
          && !user.creditedConsumerProfileType
          && !user.isWranxOrIpaProfile"
      />
      <slot name="brightedge" />
      <vf-footer-columns />
      <div class="py-8">
        <div
          v-style:w="{ md: '51rem' }"
          class="md:mx-a md:flex md:justify-center divide-x divide-grey-70 <md:divide-y"
        >
          <div v-if="!hideNewsletter" v-style:w="{ md: '30.5rem' }" class="box-content px-4 pb-8 md:pb-0 md:pl-0 md:pr-8">
            <form-newsletter
              class="w-full"
              class-heading="md:text-left"
              class-subheading="md:text-left text-sm"
              class-submit="o:md:self-start"
              form-location="inline:footer:none:none"
              :show-hint="false"
            />
          </div>
          <div class="pt-8 <md:w-full divide-y divide-grey-70 md:pl-8 md:pt-0">
            <section class="px-4 pb-8 md:pb-6 md:pr-0">
              <div>
                <h2 class="mb-2 title-3">
                  {{ $t.footerContent.storeLocator.header }}
                </h2>
                <p class="mb-6 text-sm fw-light md:mb-4">
                  {{ $t.footerContent.storeLocator.description }}
                </p>
              </div>
              <vf-button
                class="<md:w-full"
                :size="{ sm: 'sm', md: 'xs' }"
                to="/store-locator"
                @click="$gtm.push('footer.onClickFooterLink', 'Store Locator')"
              >
                {{ $t.footerContent.storeLocator.button }}
              </vf-button>
            </section>
            <section class="px-4 pt-8 md:pr-0 md:pt-6">
              <div>
                <h2 class="mb-2 title-3">
                  {{ $t.footerContent.social.header }}
                </h2>
                <div class="flex space-x-4 md:space-x-2">
                  <div v-for="(to, name) in data?.links?.social" :key="name">
                    <base-link :aria-label="name" :to>
                      <vf-icon :name size="lg" />
                    </base-link>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <vf-footer-legal-links v-if="data?.links?.legal" class="o:mx-0" :links="data.links.legal">
        <base-link class="<md:hidden" to="/">
          <vf-logo loading="lazy" style="max-width: 7.5rem" />
        </base-link>
      </vf-footer-legal-links>
    </div>
  </footer>
</template>

<script lang="ts" setup>
defineProps<{
  hideNewsletter?: boolean
}>()

const { data } = await useApi().internal.getFooter()

const { showLoyaltyFooter } = useAppConfig().components.vf.footer

const user = useUserStore()
</script>
